(() => {
  const viewport = document.querySelector('meta[name="viewport"]');
  if (!viewport) return;
  const preserveZoom = () => {
    const parts = viewport.content.split(',').map((part) => part.trim());
    const accessible = parts.filter((part) => !/^(maximum-scale|minimum-scale|user-scalable)\s*=/i.test(part)).join(', ');
    if (viewport.content !== accessible) viewport.content = accessible;
  };
  preserveZoom();
  new MutationObserver(preserveZoom).observe(viewport, { attributes: true, attributeFilter: ['content'] });
})();
